import { IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default function InputPassword(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    required = false,
    error = null,
    size = "small",
    // Matches Input.jsx and Select.jsx, which both default this true. Without it
    // MUI defaults to false and a password box renders at its intrinsic ~200px
    // while the text field beside it fills the grid cell.
    fullWidth = true,
    ...other
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => setShowPassword(!showPassword);

  return (
    <TextField
      variant={variant || "outlined"}
      label={label || "Password"}
      type={showPassword ? "text" : "password"}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      size={size}
      fullWidth={fullWidth}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleShowPassword}>
              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          </InputAdornment>
        ),
        maxLength: 100,
      }}
      {...other}
      {...(error && { error: true, helperText: error })}
    />
  );
}
